module.exports = __webpack_public_path__ + "static/logo-fastcompany-71624a81ecd618a0d809e8be2b10e803.png";